/* eslint-disable max-lines-per-function */
import React, { useCallback } from 'react';
import { resetSelect } from 'reactApp/modules/selections/selections.actions';
import { onClickCreateNew, onItemClick } from 'reactApp/ui/Datalist/UserActions/onClickAction';
import { onContextMenu, onContextMenuItem } from 'reactApp/ui/Datalist/UserActions/onContextMenuAction';
import { onDocumentClick } from 'reactApp/ui/Datalist/UserActions/onDocumentAction';
import { onBeginSelection, onSelect, onSelectBoxSelection, onSelecting } from 'reactApp/ui/Datalist/UserActions/onSelectAction';

export const useHandleCallback = ({
    isModalOpen,
    setActiveIndex,
    dispatch,
    selectedItem,
    prevSelectHandler,
    storage,
    gaSuffix,
    items,
    selectedIdxs,
    selectingIdxs,
    setSelectingIdxs,
    goTo,
    showSecondClickTip,
    handleHideTip,
    routerParams,
    itemCreateNewRef,
    viewMode,
    isPopup,
    onItemSelectCallback,
}) => {
    const handleOnDocumentClick = useCallback(
        (event: MouseEvent) => {
            onDocumentClick({ event, isModalOpen, setActiveIndex, dispatch });
        },
        [resetSelect, dispatch, isModalOpen, selectedItem]
    );

    const handleOnSelectGroupClick = useCallback((e) => {
        e.nativeEvent.stopImmediatePropagation();
        // На mousedown в SelectableGroup срабатывает onBeginSelection
        // Но не срабатывает onEndSelection
        // Поэтому дополнительно восстановим onselectstart на click
        document.onselectstart = prevSelectHandler.current;
    }, []);

    const handleBeginSelection = useCallback(
        (event) => {
            onBeginSelection({ event, dispatch, prevSelectHandler, itemCreateNewRef });
        },
        [resetSelect, dispatch, prevSelectHandler]
    );

    const handleOnContextMenu = useCallback(
        (event) => {
            onContextMenu({ event, gaSuffix, storage, isPopup });
        },
        [storage, gaSuffix, isPopup]
    );

    const handleOnContextMenuItem = useCallback(
        (event) => {
            onContextMenuItem({ event, gaSuffix, storage });
        },
        [storage]
    );

    const handleOnSelect = useCallback(
        ({ event, id, isCheckbox }: { event: React.MouseEvent; id: string; isCheckbox?: boolean }): void => {
            onSelect({ event, setActiveIndex, items, id, isCheckbox, storage, dispatch });
            onItemSelectCallback?.({ id });
        },
        [dispatch, items, storage, setActiveIndex, onItemSelectCallback]
    );

    const handleSelectboxSelection = useCallback(
        (idxs, event) => {
            onSelectBoxSelection({
                event,
                setActiveIndex,
                idxs,
                selectedIdxs,
                selectingIdxs,
                storage,
                setSelectingIdxs,
                dispatch,
                prevSelectHandler,
            });
        },
        [dispatch, setSelectingIdxs, selectingIdxs, setActiveIndex, storage, selectedIdxs]
    );

    const handleSelecting = useCallback(
        (idxs) => {
            onSelecting({ setActiveIndex, idxs, selectingIdxs, setSelectingIdxs });
        },
        [selectingIdxs, setSelectingIdxs]
    );

    const handleOnClick = useCallback(
        (id, item) => {
            onItemClick({ id, item, goTo, dispatch, showSecondClickTip, handleHideTip, storage, viewMode });
        },
        [goTo, dispatch, routerParams, showSecondClickTip, handleHideTip, viewMode]
    );

    const handleClickCreateNew = useCallback(
        (e) => {
            onClickCreateNew(e, { gaSuffix, storage });
        },
        [storage]
    );

    return {
        handleOnDocumentClick,
        handleOnSelectGroupClick,
        handleBeginSelection,
        handleOnContextMenu,
        handleOnContextMenuItem,
        handleOnSelect,
        handleSelectboxSelection,
        handleSelecting,
        handleOnClick,
        handleClickCreateNew,
    };
};
